(function () {
    'use strict';

    angular
        .module('app')
        .factory('ReportService', ReportService);

    function ReportService($http, $q, $rootScope, WebAPIUrl) {

        var service = {
            generateReport: generateReport,
            generateReportMultiParam: generateReportMultiParam
        };

        return service;

        function generateReport(reportNameData, parameterNameData, reportParametersData) {

            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Report/GenerateReport?ReportName=' + reportNameData + '&ParameterName=' + parameterNameData + '&ParameterValues=' + reportParametersData,
                //data: { reportName: reportNameData, parameterName: parameterNameData, reportParameters: reportParametersData },
                responseType: 'arraybuffer',
                //ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                function arrayBufferToString(buff) {
                    var charCodeArray = Array.apply(null, new Uint8Array(buff));
                    var result = '';
                    for (var i = 0, len = charCodeArray.length; i < len; i++) {
                        var code = charCodeArray[i];
                        result += String.fromCharCode(code);
                    }
                    return result;
                }

                err = arrayBufferToString(err);
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function generateReportMultiParam(reportName, reportParametersData) {

            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Report/GenerateReportMultiParam?ReportName=' + reportName + '&ReportParametersData=' + reportParametersData,
                //data: { reportName: reportNameData, parameterName: parameterNameData, reportParameters: reportParametersData },
                responseType: 'arraybuffer',
                //ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                function arrayBufferToString(buff) {
                    var charCodeArray = Array.apply(null, new Uint8Array(buff));
                    var result = '';
                    for (var i = 0, len = charCodeArray.length; i < len; i++) {
                        var code = charCodeArray[i];
                        result += String.fromCharCode(code);
                    }
                    return result;
                }

                err = arrayBufferToString(err);
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

    }

})();